module.exports = __webpack_public_path__ + "img/all-pass-img.051f8e32.png";